import service from "@/utils/request";
// 获取轮播图
export let getbannerlistApi = (data) => {
  return service.post(`index/banner`, data);
}
// 获取视频教程
export let getvideolistApi = (data) => {
  return service.post(`index/videolist`, data);
}

// 关于我们/印前必看/联系我们
export let getaboutlistApi = (data) => {
  return service.post(`index/aboutuslist`, data);
}
// 获取产品展示
export let getproductlistApi = (data) => {
  return service.post(`index/shopsortlist`, data);
}
// 获取产品列表
export let shoppinglistApi = (data) => {
  return service.post(`index/shoplist`, data);
}
export let newshoplistApi = (data) => {
  return service.post(`index/newshoplist`, data);
}